/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

export type DeleteDataLibraryVariableMode = typeof DeleteDataLibraryVariableMode[keyof typeof DeleteDataLibraryVariableMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeleteDataLibraryVariableMode = {
  retain: 'retain',
  remove: 'remove',
} as const;
